export enum FeedbackActionsEnum {
  FEEDBACK_RESET = 'FEEDBACK_RESET',
  FEEDBACK_POST = 'FEEDBACK_POST',
  FEEDBACK_SET_ERROR = 'FEEDBACK_SET_ERROR',
  FEEDBACK_SET_FILES = 'FEEDBACK_SET_FILES',
  FEEDBACK_UPLOAD_FILE = 'FEEDBACK_UPLOAD_FILE',
  FEEDBACK_SET_FORM = 'FEEDBACK_SET_FORM',
  FEEDBACK_SET_KNM_DATA = 'FEEDBACK_SET_KNM_DATA',
  FEEDBACK_SET_PLAN_DATA = 'FEEDBACK_SET_PLAN_DATA',
}
